
export interface ICheckForCardRequest {
    requestMode: RequestMode;
    cardIndex?: number;
    cardNumber?: string;
    iInL: string;

}

export enum RequestMode {
    Index = 1,
    FullCard = 2
}
